import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {currentSelectionActions} from '../../../../../../redux/currentSelection'
import PlannedShotBox from './PlannedShotBox'

class PlannedShotBoxContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false
    }
  }

  render () {
    const { shot, patientBirthDate } = this.props
    return <PlannedShotBox patientBirthDate={patientBirthDate} shot={shot} handleClick={() => {}} />
  }
}

PlannedShotBoxContainer.propTypes = {
  shot: PropTypes.object.isRequired
}

function mapStateToProps ({patient}) {
  return {
    patientBirthDate: patient.data.birthDate
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(currentSelectionActions, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PlannedShotBoxContainer)
